import React from 'react';
import BaseInput from '../../../Componant/Forms/FormControl/BaseInput';

const BasicInputs = () => {
  return (
    <div className='page-body'>
      <BaseInput />
    </div>
  );
};

export default BasicInputs;
